import { HTMLAttributes } from 'react';
import { cn } from '../../utils';
import { UserAvatar } from '../UserAvatar';
import { ComboboxOption } from './Combobox';

export type ComboboxAvatarItemOption = ComboboxOption<{
  avatarUrl?: string | null;
  initial?: string;
}>;

export interface ComboboxAvatarItemProps
  extends HTMLAttributes<HTMLDivElement>,
    ComboboxAvatarItemOption {}

export const ComboboxAvatarItem = ({
  label,
  avatarUrl,
  initial,
  ...props
}: ComboboxAvatarItemProps) => (
  <div
    {...props}
    className={cn('text-medium flex items-center gap-2', props.className)}
  >
    {initial && (
      <UserAvatar
        variant="small"
        avatarImageProps={{ ...(avatarUrl && { avatarUrl }) }}
        avatarFallbackProps={{ initials: initial }}
        className="ml-0 size-6 text-xs"
      />
    )}
    <span className="text-primary leading-4.5 font-semibold">
      {label || ''}
    </span>
  </div>
);
